import ItemViewState from '../store/schema/ItemViewState';

export default function getInfoBarMessageIdsInReadingPane(viewState: ItemViewState): string[] {
    return viewState.infoBarIds;
}
